module.exports = __webpack_public_path__ + "img/pasosjw.d76ad6e2.png";